import { FC } from "react"
import { useTranslation } from "react-i18next";
import { Icon } from "Components/UI/Icon"
import { Container } from "./styles";

interface INoResults {
  search?: string;
}

export const NoResults: FC<INoResults> = ({ search }) => {
  const { t } = useTranslation('obras');
  return (
    <Container>
      <div className="text-container">
        <div className="icon-container">
          <Icon icon='buscar' customSize={24} className="iconSearch" />
        </div>
        <p className="title">
          {t('noResultsTitle', { search })}
        </p>
        <p className="description">
          {t('noResultsDescription')}
        </p>
      </div>
    </Container>
  )
}
